import { ReactNode } from 'react';
import './CardsGrid.scss';
import Card from './Card';

export type Card = {
    title: string;
    content: ReactNode
}

const Cards = ({
    sectionTitle,
    cards
} : {
    sectionTitle: string;
    cards?: Card;
}) => {
    return (
        <section className="cards">
            <h2 className='cards-title'>{sectionTitle}</h2>
            <div className="cards-items">
                <Card>
                    <h3 className='card-title a'>✨ Authenticity</h3>
                    <p>We value authenticity to the highest degree and understand how 
                        important it is to be transparent and honest. We only create high-quality 
                        and real work: real data backed by real-world experiences.
                    </p>
                </Card>
                <Card>
                    <h3 className='card-title a'>⚖️ Equity</h3>
                    <p>We understand that not everything has a one-size-fits-all solution, and sometimes things look different for different people. We practice equity across all sectors and interactions.
                    </p>
                </Card>
                <Card>
                    <h3 className='card-title a'>🧠 Innovation</h3>
                    <p>
                    Our philosophy is to continue pushing past the status quo, being bold and curious, and learning from our wins and losses. We value learning and education to the highest degree.
                    </p>
                </Card>
                <Card>
                    <h3 className='card-title a'>💛 Compassion</h3>
                    <p>
                    Our philosophy is to continue pushing past the status quo, being bold and curious, and learning from our wins and losses. We value learning and education to the highest degree.
                    </p>
                </Card>
                <Card>
                    <h3 className='card-title a'>🌈 Diversity</h3>
                    <p>
                    Our philosophy is to continue pushing past the status quo, being bold and curious, and learning from our wins and losses. We value learning and education to the highest degree.
                    </p>
                </Card>
                <Card>
                    <h3 className='card-title a'>🫂 Community</h3>
                    <p>
                    Our philosophy is to continue pushing past the status quo, being bold and curious, and learning from our wins and losses. We value learning and education to the highest degree.
                    </p>
                </Card>
            </div>
        </section>
    )
}

export default Cards;